import React from 'react'
import { Icon, Feed } from 'semantic-ui-react'
// import './Card.css';
const UserName = (props) => (


    <Feed size='small' style={{paddingTop: 0}}>
    <Feed.Event >
      <Feed.Label>
        <img style={{paddingTop: 5}} src={props.creator.avatar} onError={(e) => e.target.style.display='none' }/>
      </Feed.Label>
      <Feed.Content >
        <Feed.Summary style={{width: props.width}}>
          <Feed.User className='dcorange' id="creator_name" href={props.creator.url} target='_blank'>
              {props.creator.name}
          </Feed.User>
          {action_name!='assignment' && props.hide_joint_at != true &&
            <p>
            <span style={{color: props.color ? props.color : '#ffffff', fontSize: 10}}>Joined at </span>
            <span style={{color: props.color ? props.color : '#ffffff', fontSize: 10}}>
            {props.creator.created_at}
            </span>
            </p>
          }

            {
            props.creator.class_room_name &&
            <p>
            <span style={{color: props.color ? props.color : '#ffffff', fontSize: 10}}>{l.classroom}: </span>
            <span style={{color: props.color ? props.color : '#ffffff', fontSize: 10}}>
            {props.creator.class_room_name}
            </span>
            </p>
            }
        </Feed.Summary>
      </Feed.Content>
    </Feed.Event>
      </Feed>



)

export default UserName
